import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ErrorStateService, RegistrationStepQuery, RegistrationStepService, StepType } from '@fgb/core';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { RegistrationNavigationModule } from '@fgb/portal-component-library/src/lib/registration';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { ErrorsModule } from '@fgb/portal-component-library/src/lib/shared/errors';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'fgbcl-registration-account-verification',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RegistrationNavigationModule,
    RouterModule,
    ReactiveFormsModule,
    FGBSharedModule,
    PipesModule,
    ErrorsModule,
  ],
  templateUrl: './registration-account-verification.component.html',
  styleUrl: './registration-account-verification.component.scss',
})
export class RegistrationAccountVerificationComponent implements OnInit {
  // Input property to determine if the component is used as a form, for re-usability
  @Input() isForm: boolean = false;
  @Output() onSubmit: EventEmitter<{ valid: boolean; email: string }> = new EventEmitter();
  @Output() onCancel: EventEmitter<void> = new EventEmitter<void>();
  readonly stepType = StepType.AccountVerify;
  private registrationStepService = inject(RegistrationStepService);
  private registrationQuery = inject(RegistrationStepQuery);
  @Input() emailAddress: string = '';
  emailFormControl: FormControl = new FormControl('', [
    Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,3}$'),
    Validators.required,
  ]);
  errorService = inject(ErrorStateService);

  ngOnInit(): void {
    if (this.isForm) {
      this.emailFormControl.setValue(this.emailAddress);
      return;
    }
    const personalDetailsData = this.registrationQuery.getStep(StepType.PersonalDetails)?.Data;
    if (personalDetailsData?.EmailAddress1) {
      this.emailAddress = personalDetailsData.EmailAddress1;
      this.emailFormControl.setValue(this.emailAddress);
    }
    lastValueFrom(this.registrationStepService.fetchRegistrationStepForCurrentWizard(this.stepType, true));
  }

  cancel(): void {
    if (this.isForm) {
      this.onCancel.emit();
    }
  }

  onInput(e: any): void {
    this.errorService.clearErrors();
  }

  submitStep(): void {
    this.emailFormControl.markAllAsTouched();
    if (this.isForm) {
      this.onSubmit.emit({ valid: this.emailFormControl.valid, email: this.emailFormControl.value });
      return;
    }
    if (this.emailFormControl.valid) {
      lastValueFrom(
        this.registrationStepService.submitRegistrationStepData(this.stepType, { EmailAddress: this.emailFormControl.value })
      );
    }
  }
}
